const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('sycho-uikit', 'common/components/Label');